import React from 'react';
import { TextContent } from '@/components/Text';
import { SkillLevelScale } from '@/components/Score';
import { cn } from '@/utils';
import { TScoreSkillLevel } from '@/types';
import { IScorecardActions } from '../types';

export interface SkillLevelSectionProps {
  actions?: IScorecardActions;
  description?: string;
  isLoading?: boolean;
  level?: TScoreSkillLevel | null;
  showSkillScale?: boolean;
  skillLevelScaleClassName?: string;
}

export const SkillLevelSection: React.FC<SkillLevelSectionProps> = ({
  actions,
  description,
  isLoading = false,
  level,
  showSkillScale = true,
  skillLevelScaleClassName,
}) => {
  if (!showSkillScale && !description) return null;

  return (
    <div
      className={cn('my-2 flex flex-col', {
				'gap-3': showSkillScale && description,
        'mb-0':
          actions?.primary?.className?.includes('hidden') &&
          actions?.secondary?.className?.includes('hidden'),
      })}
    >
      {showSkillScale && (
        <SkillLevelScale
          className={skillLevelScaleClassName}
          level={level}
          showLabels={true}
          isLoading={isLoading}
        />
      )}

      {description && (
        <TextContent
          className="space-y-0.5"
          color="neutral-black"
          isLoading={isLoading}
          label={description}
          loadingClassName="h-4 w-full rounded"
          loadingLines={2}
          type="paragraph"
        />
      )}
    </div>
  );
};

SkillLevelSection.displayName = 'SkillLevelSection';

export default SkillLevelSection;
